import { useState } from 'react';
import { Alert, Button, Divider, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';

export default function T2wPromptSettings({ deployment, onSave }) {
  const [multiPrompt, setMultiPrompt] = useState(
    deployment?.config?.multiSupportCorrectionPrompt || '',
  );
  const [singlePrompt, setSinglePrompt] = useState(
    deployment?.config?.singleSupportCorrectionPrompt || '',
  );

  const handleSave = async () => {
    onSave({
      multiSupportCorrectionPrompt: multiPrompt,
      singleSupportCorrectionPrompt: singlePrompt,
    });
  };

  return (
    <Box
      sx={{
        pb: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ mb: 4 }}>
        <Box sx={{ my: 1, mb: 2, pr: '80px' }}>
          <Typography variant="h6">KI-Prompt Konfiguration</Typography>
          <Divider />
        </Box>

        <Box sx={{ height: '650px', overflowY: 'auto' }}>
          <Alert severity="info" sx={{ mb: 3, mt: 2 }}>
            Hier können die Prompts für die KI-gestützte Textkorrektur angepasst
            werden.
          </Alert>
          <TextField
            label="Prompt für Einzelkorrektur"
            multiline
            minRows={4}
            fullWidth
            value={singlePrompt}
            onChange={(e) => setSinglePrompt(e.target.value)}
          />
          <TextField
            sx={{ mt: 2 }}
            label="Prompt für Mehrfachkorrektur"
            multiline
            minRows={4}
            fullWidth
            value={multiPrompt}
            onChange={(e) => setMultiPrompt(e.target.value)}
          />
        </Box>
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{ mt: 'auto', ml: 'auto' }}
      >
        Speichern
      </Button>
    </Box>
  );
}
